import { useMemo } from "react";
import Tasks from "./Tasks";
import { Provider } from "react-redux";

const TaskApp = (props) => {
  const store = useMemo(() => ReactOnRails.getStore("layoutStore"), []);
  return (
    <Provider store={store}>
      <Tasks
        admin={props.admin}
        ids={props.ids}
        agent={props.agent}
        dueness={props.dueness}
        orderBy={props.orderBy}
        orderDirection={props.orderDirection}
      />
    </Provider>
  );
};

export default TaskApp;
